/** @jsxImportSource theme-ui */
import { Box, Text, Button as ThemeUiButton } from "theme-ui";

import { SvgOrImg } from "components";
import * as styles from "./ProductButtonV2.styles";
import { ArrowRightIcon } from "components/icons";

export default function ProductButtonV2({
  description,
  subText,
  selectLabel = "SELECT",
  color,
  backgroundColor,
  backgroundImage,
  isSelected = false,
  onClick,
  logos,
  cornerTag,
  ...props
}) {
  return (
    <ThemeUiButton
      aria-label={logos[0].alt}
      variant="unstyled"
      onClick={onClick}
      sx={styles.cardButton({
        backgroundColor,
        color,
      })}
      {...props}
    >
      {cornerTag && (
        <Box sx={styles.cornerTag}>
          {cornerTag.logo && (
            <SvgOrImg
              key={cornerTag.logo.alt}
              src={cornerTag.logo.url}
              alt={cornerTag.logo.alt}
              sx={styles.cornerTagImg}
            />
          )}
          <Text sx={styles.cornerTagText}>{cornerTag.text}</Text>
        </Box>
      )}

      <Box sx={styles.backgroundWrapper({ backgroundImage })}>
        <Box sx={styles.labelBox}>
          {description && (
            <Text variant="h5" sx={styles.description}>
              {description}
            </Text>
          )}

          <Box sx={styles.logoContainer({ nLogos: logos.length })}>
            {logos.map(({ url, alt, widthOverride }) => {
              return (
                <SvgOrImg
                  key={alt}
                  src={url}
                  alt={alt}
                  sx={styles.logo({ nLogos: logos.length, widthOverride })}
                />
              );
            })}
          </Box>

          {subText && (
            <Text variant="h5Light" sx={styles.subText}>
              {subText}
            </Text>
          )}
          {!isSelected && (
            <Box sx={styles.selectLabel}>
              {selectLabel}
              <ArrowRightIcon />
            </Box>
          )}
        </Box>
      </Box>
    </ThemeUiButton>
  );
}
